import React from "react";
import {
  Container,
  ButtonGroup,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import PersonalInjuryForm from "./ConsultationForms/PersonalInjury";
import MediationForm from "./ConsultationForms/MediationForm";
import IntellectualPropertyForm from "./ConsultationForms/IntellectualPropertyForm";
import moment from "moment";

export default function ConsultationModal({requestSubmitted, setRequestSubmitted}) {
  const [consultationType, setConsultationType] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const oneWeekExpiry = moment().subtract(7, "days");
  console.log(oneWeekExpiry)
  console.log(requestSubmitted)

  const updateConsultationType = (event) => {
    setConsultationType(event.target.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setConsultationType("");
    setOpen(false);
  };

  React.useEffect(()=>{},[requestSubmitted, setRequestSubmitted])
  const matches = useMediaQuery("(min-width:600px)");

  return (
    <div>
      {moment(requestSubmitted).isSameOrBefore(oneWeekExpiry) || !requestSubmitted ? (
        <Button variant="contained" onClick={handleClickOpen} >
          <Typography variant="h6" sx={{fontWeight:"bold"}}>Free Consultation</Typography>
        </Button>
      ) : (
        <Button variant="contained" onClick={handleClickOpen} sx={{ fontWeight:"400"}}>
          <Typography variant="h6" sx={{fontWeight:"bold"}}>Thank You for Your Request</Typography>
        </Button>
      )}
      <Dialog  open={open} onClose={handleClose}>
        <DialogTitle>Consultation Request</DialogTitle>
        {moment(requestSubmitted).isSameOrBefore(oneWeekExpiry) || !requestSubmitted ? (
          <DialogContent>
            <DialogContentText>
              To request a free consultation, please enter your email address
              and short description of your case here.
            </DialogContentText>
            <Container fullWidth sx={{ display: "flex", alignItems: "center", justifyContent:"center", }}>
              <Container
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  padding: "10px 0px",
                  margin:'20px',
                  height:"fit-content"
                }}
              >
                <ButtonGroup
                  variant="contained"
                  aria-label="outlined primary button group"
                  size={`${matches ? `large` : `small`}`}
                >
                  <Button
                    value="Personal Injury"
                    onClick={updateConsultationType}
                  >
                    Personal Injury
                  </Button>
                  <Button value="Mediation" onClick={updateConsultationType}>
                    Mediation
                  </Button>
                  <Button
                    value="Intellectual Property"
                    onClick={updateConsultationType}
                  >
                    Intellectual Property
                  </Button>
                </ButtonGroup>
              </Container>
            </Container>
            {consultationType === "Personal Injury" && (
              <PersonalInjuryForm
                handleClose={handleClose}
                setRequestSubmitted={setRequestSubmitted}
              />
            )}
            {consultationType === "Mediation" && (
              <MediationForm
                handleClose={handleClose}
                setRequestSubmitted={setRequestSubmitted}
              />
            )}
            {consultationType === "Intellectual Property" && (
              <IntellectualPropertyForm
                handleClose={handleClose}
                setRequestSubmitted={setRequestSubmitted}
              />
            )}
          </DialogContent>
        ) : (
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <DialogContentText sx={{ padding: "0px 0px 10px 0px" }}>
              Thank you for your interest. Please wait at least 7 days before
              submitting another request. You may also contact Edward Russell
              Law directly by going to the contact section of our website.
            </DialogContentText>
            <Button color="primary" variant="contained" onClick={handleClose}>
              Close
            </Button>
          </DialogContent>
        )}
      </Dialog>
    </div>
  );
}
